angular.module('jrGoogleTagManager', ['jrConfig']).factory('GoogleTagManagerService', [
  'GoogleTagManagerConfig',
  '$q',
  function (GoogleTagManagerConfig, $q) {
    const { dataLayer } = GoogleTagManagerConfig;

    return {
      pushEvent(eventName, dataLayerObject) {
        const deferred = $q.defer();
        const dataLayerObjectDefault = {
          event: eventName,
          eventCallback(gtmData) {
            deferred.resolve(gtmData);
          },
        };

        dataLayer.push(
          angular.extend(
            dataLayerObjectDefault,
            angular.isDefined(dataLayerObject) ? dataLayerObject : {}
          )
        );
        return deferred.promise;
      },
    };
  },
]);
